import React, {useEffect, useState} from 'react';
import {AnyColumnJson} from "../../api/json/ColumnJson"
import {DragDropContext, Draggable, Droppable, DropResult} from "@hello-pangea/dnd"
import {Box, Stack, SxProps} from "@mui/material"
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

function ColumnOrderList({columns, startsAt, onChange, sx}: { columns: AnyColumnJson[], startsAt?: number, onChange: (updated: AnyColumnJson[]) => void, sx?: SxProps }) {
    const [ordered, setOrdered] = useState<AnyColumnJson[]>(columns)

    const handleDragEnd = (result: DropResult) => {
        if (!result.destination) return

        let list = [...ordered]
        const [removed] = list.splice(result.source.index, 1);
        list.splice(result.destination?.index, 0, removed);

        // Set the order for each column
        list = list.map((column, index) => {
            return {
                ...column,
                order: index + (startsAt ?? 0)
            };
        });

        setOrdered(list)
    }

    useEffect(() => {
        // Call onChange if the order has changed
        if (ordered.some((item, index) => item.id !== columns[index].id)) {
            onChange(ordered);
        }
    }, [ordered])

    return (
        <Box sx={sx}>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppable" direction="vertical">
                    {(provided, snapshot) => (
                        <Stack spacing={1} ref={provided.innerRef} {...provided.droppableProps} sx={{cursor: "grab"}}>
                            {ordered.map((column, index) => (
                                <Draggable key={column.id} draggableId={column.id!} index={index}>
                                    {(provided, snapshot) => (
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={provided.draggableProps.style}
                                        >
                                            <DragIndicatorIcon/>
                                            <Box>
                                                {column.name}
                                            </Box>
                                        </Stack>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </Stack>
                    )}
                </Droppable>
            </DragDropContext>
        </Box>
    );
}

export default ColumnOrderList;